// Right side of the dashboard's row-2: "Next that matters".
// V1 stub: shows a connect-a-notetaker pad if the user has no source connected
// or no upcoming meetings (the upcoming-meetings API is out of scope for this
// PR). When real upcoming data lands, swap the stub branch for a populated
// state and keep the visual chassis intact.

import { Link } from "react-router";

export type UpcomingTileProps =
  | { kind: "stub"; connected: boolean }
  | {
      kind: "populated";
      whenLabel: string;
      title: string;
      body: string;
      prepTo: string;
      historyTo: string;
    };

export function UpcomingTile(props: UpcomingTileProps) {
  if (props.kind === "stub") {
    return (
      <aside className="upcoming">
        <div className="l-row">
          <span className="l">Next that matters</span>
        </div>
        <h3>
          {props.connected
            ? "No upcoming meetings on your notetaker yet."
            : "Connect a notetaker to see what's next."}
        </h3>
        <p>
          {props.connected
            ? "When Granola or Fathom syncs an upcoming call, it lands here with prep notes and a one-click read."
            : "Granola and Fathom both feed Klemento upcoming meetings. Connect one in Settings."}
        </p>
        <div className="upcoming-cta">
          <Link to="/settings" className="btn-out">
            {props.connected ? "Manage notetakers" : "Connect"}
          </Link>
        </div>
      </aside>
    );
  }

  return (
    <aside className="upcoming">
      <div className="l-row">
        <span className="l">Next that matters</span>
        <span className="when-pill">{props.whenLabel}</span>
      </div>
      <h3>{props.title}</h3>
      <p>{props.body}</p>
      <div className="upcoming-cta">
        <Link to={props.prepTo} className="btn-out solid">Prep notes</Link>
        <Link to={props.historyTo} className="btn-out">History</Link>
      </div>
    </aside>
  );
}
